import { footerColumns, navLinks } from "@/mocks/home";
import BrandMark from "@/pages/home/components/BrandMark";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-14 md:px-8 md:py-16">
        <div className="flex flex-col items-center gap-5 rounded-3xl bg-primary-500 px-6 py-10 text-center md:flex-row md:justify-between md:px-12 md:text-left">
          <div className="max-w-xl">
            <h2 className="font-heading text-xl font-black text-background-50 md:text-3xl">
              现在打开，就能刷到对味的那一条
            </h2>
            <p className="mt-3 font-body text-sm leading-7 text-background-50/85">
              热门短视频、福利视频与最新资源都在首页，分类清晰，随时随地免费畅看。
            </p>
          </div>
          <a
            href="#top"
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 font-label text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
          >
            <i className="ri-play-circle-line text-lg"></i>
            免费畅看热门视频
          </a>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <BrandMark size="lg" />
            <p className="mt-4 max-w-sm font-body text-sm leading-7 text-foreground-600">
              糖豆视频聚合短视频、福利视频与最新资源，分类清晰、更新及时，高清流畅不卡顿，
              让每次打开都有值得看的内容。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line", "ri-rss-line"].map((icon) => (
                <a
                  key={icon}
                  href="#top"
                  aria-label="糖豆视频社交入口"
                  className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-background-300/70 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  <i className={`${icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h3 className="font-label text-sm font-semibold text-foreground-950">{col.title}</h3>
              <ul className="mt-4 flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="cursor-pointer font-body text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1">
            <h3 className="font-label text-sm font-semibold text-foreground-950">快捷</h3>
            <ul className="mt-4 flex flex-col gap-3">
              {navLinks.slice(0, 3).map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="cursor-pointer whitespace-nowrap font-body text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="font-body text-xs text-foreground-500">
            © 2026 糖豆视频 · 本站为内容展示页，所有内容仅供浏览参考
          </p>
          <div className="flex items-center gap-5">
            <a href="#top" className="cursor-pointer font-body text-xs text-foreground-500 hover:text-primary-600">
              使用条款
            </a>
            <a href="#top" className="cursor-pointer font-body text-xs text-foreground-500 hover:text-primary-600">
              隐私说明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}